import { useState } from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { useTranslate } from 'react-admin';

import { DashboardContent } from 'src/layouts/dashboard';
import { PermissionGuard } from 'src/routes/components/permission-guard';
import ErrorPage403 from 'src/pages/error/403';

import { DashboardV3TopTabs } from './components/DashboardV3TopTabs';
import { TAB_LABELS } from './mock-data';
import { DepositsPage } from './modules/deposits/DepositsPage';
import { OverviewPage } from './modules/overview/OverviewPage';
import { ReferralPage } from './modules/referral/ReferralPage';
import { RetentionPage } from './modules/retention/RetentionPage';
import { TradingPage } from './modules/trading/TradingPage';
import { UsersPage } from './modules/users/UsersPage';

export type DashboardV3TabValue = (typeof TAB_LABELS)[number]['value'];

function ComingSoonPanel({ title }: { title: string }) {
    return (
        <Paper
            sx={{
                mt: 3,
                p: 4,
                bgcolor: '#232323',
                border: '1px solid rgba(255,255,255,0.08)',
                color: '#FFFFFF',
            }}
        >
            <Typography variant="h6" sx={{ fontWeight: 700 }}>
                {title}
            </Typography>
            <Typography sx={{ mt: 1, color: 'rgba(255,255,255,0.55)' }}>
                页面开发中
            </Typography>
        </Paper>
    );
}

export const MainPage = () => {
    const t = useTranslate();
    const [activeTab, setActiveTab] = useState<DashboardV3TabValue>('overview');

    const activeTabLabel =
        TAB_LABELS.find((item) => item.value === activeTab)?.labelKey ?? '';

    return (
        <PermissionGuard resource="dashboard-v3" action="read" fallback={<ErrorPage403 />}>
            <Box
                sx={{
                    background: '#1F1B33',
                    boxShadow: '0 8px 24px rgba(0, 0, 0, 0.18)',
                    display: 'flex',
                    position: 'sticky',
                    top: 64,
                    zIndex: 90,
                    overflowX: 'auto',
                    px: 1,
                    py: 0.5,
                    mt: 2,
                    '&::-webkit-scrollbar': { display: 'none' },
                }}
            >
                <DashboardV3TopTabs activeTab={activeTab} onChange={setActiveTab} />
            </Box>

            <DashboardContent sx={{ pb: 0, bgcolor: '#121212', minHeight: 'calc(100vh - 64px)' }}>
                {activeTab === 'overview' && <OverviewPage />}
                {activeTab === 'users' && <UsersPage />}
                {activeTab === 'deposit' && <DepositsPage />}
                {activeTab === 'trading' && <TradingPage />}
                {activeTab === 'retention' && <RetentionPage />}
                {activeTab === 'referral' && <ReferralPage />}

                {activeTab !== 'overview' &&
                    activeTab !== 'users' &&
                    activeTab !== 'deposit' &&
                    activeTab !== 'trading' &&
                    activeTab !== 'retention' &&
                    activeTab !== 'referral' && (
                        <ComingSoonPanel title={t(activeTabLabel, { _: activeTabLabel })} />
                    )}
            </DashboardContent>
        </PermissionGuard>
    );
};
